import { render, staticRenderFns } from "./WxLossDetermDialog.vue?vue&type=template&id=4c99968d&scoped=true&"
import script from "./WxLossDetermDialog.vue?vue&type=script&lang=js&"
export * from "./WxLossDetermDialog.vue?vue&type=script&lang=js&"
import style0 from "./WxLossDetermDialog.vue?vue&type=style&index=0&id=4c99968d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c99968d",
  null
  
)

export default component.exports